import React from "react";
import { SearchAllocatorsCard } from "@hedgefund/shared";
import { useDispatch, useSelector } from "react-redux";
import { Input, Button, DropDown } from "@public/ui-toolkit";
import debounce from "lodash/debounce";
import { 
  // CreateAuditLogs, 
  getSearchAllocators 
} from "./actions";
import { useQuery } from "../../utils/CustomHook";
// import jwtDecode from "jwt-decode";

export const aumData = [
  { option: "All", value: "all" },
  { option: "$0-25mm", value: "0-25000000" },
  { option: "$25-50mm", value: "25000000-50000000" },
  { option: "$50-100mm", value: "50000000-100000000" },
  { option: "$100-250mm", value: "100000000-250000000" },
  { option: "$250-500mm", value: "250000000-500000000" },
  { option: "$500-1bn", value: "500000000-1000000000" },
  { option: "$1bn-2bn", value: "1000000000-2000000000" },
  { option: "$3bn-4bn", value: "2000000000-3000000000" },
  { option: "$4bn-5bn", value: "4000000000-5000000000" },
  { option: "$100bn-200bn", value: "100000000000-200000000000" },
  { option: "$200bn-500bn", value: "200000000000-500000000000" },
];

const SearchFund = () => {
  const query = useQuery();
  const searchOptions = query.get("keyword") || "";
  const dispatch = useDispatch();
  const [search, setSearch] = React.useState(searchOptions);
  const [firstCall, setFirstCall] = React.useState(true);
  const [aum, setAum] = React.useState({
    min: "",
    max: "",
  });
  const [paginationInfo, setPaginationInfo] = React.useState({
    page: 1,
    perPage: 20,
  });
  const [filterAUMShow, setFilterAUMShow] = React.useState(false);

  const dropDownAumValue = query.get("dropDownAumValue") || null;

  const searchAllocatorsStore = useSelector(
    (state) => state.searchAllocatorReducer
  );

  React.useEffect(() => {
    setPaginationInfo({ ...paginationInfo, page: 1 });
    const payload = {
      keyword: search,
      page: 1,
      perPage: paginationInfo.perPage,
      min: aum?.min ? aum?.min : "",
      max: aum?.max ? aum?.max : "",
    };
    if (firstCall) {
      dispatch(getSearchAllocators(payload));
    }
  }, [search, dispatch, aum]);

  React.useEffect(() => {
    if (dropDownAumValue) {
      const result = aumData?.find(
        ({ option }) => option === (dropDownAumValue || "")
      );
      const { value } = result;

      if (value === "all") {
        setAum();
      } else if (value !== "all") {
        const splitNumbers = value?.split("-");
        const min = splitNumbers || "";
        const max = splitNumbers || "";
        setAum({
          min: min[0],
          max: max[1],
        });
      }
    }
  }, [dropDownAumValue]);

  const { searchAllocators, rows,page } = searchAllocatorsStore;

  const handleSearch = debounce((text) => {
    setSearch(text);
  }, 1000);

  const onClickCrossAumHandler = () => {
    setFilterAUMShow([]);
    setAum({ min: "", max: "" });
  };

  const onChangeAumDataHandle = (e) => {
    const { value } = aumData.find(({ option }) => e === option);
    if (value === "all") {
      setFilterAUMShow(false);
      setAum({ min: "", max: "" });
    } else if (value !== "all") {
      const values = value.split("-");
      const min = values[0];
      const max = values[1];

      setAum({
        min: parseInt(min),
        max: parseInt(max),
      });

      setFilterAUMShow(e);
    }
  };

  const handleMore = () => {
    const payload = {
      keyword: search,
      page: page + 1,
      perPage: paginationInfo.perPage,
    };
    dispatch(getSearchAllocators(payload));
  };
  return (
    <main>
      <div className="main-inner">
        <div className="container mt-5">
          {/* <div className="main-content-header py-4">
            <Breadcrumbs item1="Search Allocators" />
          </div> */}
          <div>
            <h4 className="stylish-title text-blue">Allocators</h4>
          </div>
          <div className="fund-searching mt-4">
            <div className="search-with-btn">
              <form>
                <div className="col-10 mr-3">
                  <Input
                    placeholder="Search"
                    label="Search"
                    onChange={(e) => handleSearch(e.target.value)}
                    type="text"
                    defaultValue={search}
                  />
                </div>
                <div className="col-2">
                  <Button btnName="Search" btnType="!primary" />
                </div>
              </form>
            </div>
            <div className="bs4-row justify-content-center mt-4">
              {Boolean(filterAUMShow?.length) && (
                <div className="mt-3  mr-3">
                  <span className="mr-2 ">Aum: {filterAUMShow}</span>
                  <button
                    className="close-btn"
                    onClick={onClickCrossAumHandler}
                  >
                    X
                  </button>
                </div>
              )}
              <div className="px-2 mb-3">
                <DropDown
                  type="primary"
                  onChange={onChangeAumDataHandle}
                  dropDownData={aumData}
                  defaultOptionName="AUM"
                  value={filterAUMShow || dropDownAumValue}
                />
              </div>
            </div>
          </div>
          <div className="mt-5">
            <div className="row gy-4">
              {searchAllocators.map((allocator) => (
                <div className="col-xl-3 col-lg-4 col-md-6">
                  <SearchAllocatorsCard
                    img={
                      allocator?.coverImageUrl
                        ? allocator?.coverImageUrl
                        : "/assets/images/bg1.png"
                    }
                    logo={
                      allocator?.logo
                        ? allocator?.logo
                        : "/assets/images/bg1.png"
                    }
                    allocator={allocator}
                    btnName="+ Follow allocator"
                    paraText=""
                    office="Office"
                    officeAddress={
                      allocator.address ? allocator.address : "Not Available"
                    }
                    aum="AUM"
                  />
                </div>
              ))}
            </div>
            {rows > paginationInfo.perPage * page  && (
              <div className="d-flex justify-content-center mt-5">
                <Button btnName="Load More +" onClick={handleMore} />
              </div>
            )}
          </div>
        </div>
      </div>
    </main>
  );
};

export default SearchFund;
